module.exports = __webpack_public_path__ + "static/media/energy-manager.ee2499c4.svg";